module.exports = __webpack_public_path__ + "assets/media/default-avatar.10207647.png";